import { Message } from 'element-ui'

export function baseMessage(msg = '', type = 'success', duration = 3000) {
  let icon = ''
  let customClass = ''
  switch (type) {
    case 'success':
      icon = 'el-icon-check'
      customClass = 'successMessage'
      break
    case 'error':
      icon = 'el-icon-close'
      customClass = 'errorMessage'
      break
    case 'warning':
      icon = 'el-icon-warning'
      customClass = 'warningMessage'
      break
    case 'info':
      icon = 'el-icon-info'
      customClass = 'infoMessage'
      break
    default:
      icon = 'el-icon-check'
  }
  Message({
    message: msg,
    type: type,
    duration: duration,
    customClass,
    iconClass: icon
  })
}
